var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-400 font-serif full"},[(_vm.item.component)?_c(_vm.item.component,{tag:"component",staticClass:"full",attrs:{"item":_vm.item}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }